import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Mail, Heart } from 'lucide-react';
import SupportModal from '../components/SupportModal';
import '../SlidingText.css';
import { useState, useEffect } from 'react';

export default function Home() {
  const { user } = useAuth();
  const feedbackLink = `mailto:markbriankiunga@gmail.com?subject=${encodeURIComponent(
    "VALENTINE'S WEBSITE FEEDBACK"
  )}&body=${encodeURIComponent(
    "Please include your feedback about:\n\n1. Website design and appearance\n2. Ease of use\n3. Features you'd like to see\n4. Any issues encountered\n5. Overall experience"
  )}`;

  const promoMessages = [
    'Flowers wilt. Chocolates melt. But a custom Valentine’s page? That’s forever! 💘',
    'For the price of one overpriced chocolate bar, you can create a whole romantic experience! 🍫🚫💻✅',
    'Skip the clichés! Ditch the teddy bears and give them a digital love letter they’ll never forget. 🧸➡️💌',
    'Why spend thousands on gifts when Ksh 0-300 can make their heart race? 💸❤️',
    'No Valentine? No worries! Manifest one by sending yourself a love page. 😂💖',
    'Give them something so romantic, even Cupid would be jealous! 🏹🔥',
    'Chocolate is temporary. A personalized Valentine’s page is legendary. 🍫❌❤️✅',
    'Love is priceless, but this is actually super affordable. 😍💰',
    'Roses are red, violets are blue, your love deserves more than a card—give them a whole website too! 🌹💻',
  ];

  const [randomPromo, setRandomPromo] = useState('');

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * promoMessages.length);
    setRandomPromo(promoMessages[randomIndex]);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 h-screen flex flex-col justify-between">
      {/* Centered Main Content */}
      <SupportModal />
      <div className="flex-grow flex items-center justify-center">
        <div className="text-center">
          <div className="animate-float">
            <Heart className="w-16 h-16 mx-auto text-pink-600" />
          </div>

          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Create Your Perfect Valentine
          </h1>
          <p className="text-xl text-gray-600 mb-8 font-dancing drop-shadow-lg">
            {randomPromo}
          </p>
          {user ? (
            <Link
              to="/create"
              className="inline-block bg-pink-600 text-white px-8 py-3 rounded-lg hover:bg-pink-700 transition-colors"
            >
              Create Valentine Page
            </Link>
          ) : (
            <Link
              to="/register"
              className="inline-block bg-pink-600 text-white px-8 py-3 rounded-lg hover:bg-pink-700 transition-colors"
            >
              Get Started
            </Link>
          )}
        </div>
      </div>

      {/* Footer at the bottom */}
      <footer className="pt-4 border-t border-red-100 text-center text-gray-600">
        <a
          href={feedbackLink}
          className="animate-float inline-flex items-center px-6 py-3 bg-gray-600 text-white rounded-full hover:bg-gray-700 transition-colors duration-200 text-lg font-semibold shadow-lg hover:shadow-xl mb-4"
        >
          <Mail className="w-5 h-5 mr-2" />
          Send Feedback
        </a>

        <p className="text-base text-gray-500 text-center">
          Crafted with ❤️ by{' '}
          <a
            href="https://linktr.ee/markbkiunga"
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-600 font-semibold hover:underline transition-colors"
          >
            Mark Brian
          </a>
        </p>
      </footer>
      <div className="sliding-text">
        <span>
          Your messages and recipient details are fully encrypted in the
          database—only you and your special someone can see them, not even me!
          To keep your surprises extra safe, each Valentine’s page requires a
          unique view password. So your love stays private, just the way it
          should be. 💕
        </span>
      </div>
    </div>
  );
}
